<div class="alert alert--danger ion-margin-vertical">
  <p class="strong">Failed to connect to Housekeep</p>
  <p>Please check your internet connection and try again.</p>
  <div class="alert__cta-btn">
    <ion-button (click)="doRefresh()" color="light" fill="outline" size="small">
      Retry
    </ion-button>
  </div>
</div>
